if (!customElements.get('mthr-core-benefits')) {
  customElements.define('mthr-core-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const topics = [...this.querySelectorAll('details')];
      const show = (topic) => {
        topics.forEach(item => { item.open = item === topic; });
        this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== topic.dataset.benefit; });
      };
      topics.forEach(topic => {
        topic.querySelector('summary').addEventListener('click', event => { event.preventDefault(); show(topic); });
        topic.addEventListener('toggle', () => { if (topic.open) show(topic); });
      });
      this.addEventListener('shopify:block:select', event => {
        const topic = event.target.closest('details');
        if (topic && this.contains(topic)) show(topic);
      });
    }
  });
}
